<script>
import popupDateTimePicker from "@/components/base/popup/popupDateTimePicker";

const defaultCancelButtonText = "取消";
const defaultClearButtonText = "清空";

export default {
  name: "formDatePicker",
  components: {
    popupDateTimePicker
  },
  props: {
    //值
    value: {
      type: [String, Number],
      default: ""
    },
    //标题
    title: {
      type: String,
      default: ""
    },
    //标题宽度
    titleWidth: {
      type: String,
      default: ""
    },
    //必填
    required: {
      type: Boolean,
      default: false
    },
    //只读
    readonly: {
      type: Boolean,
      default: false
    },
    //禁用
    disabled: {
      type: Boolean,
      default: false
    },
    //最小时间
    minDate: {
      type: String,
      default: ""
    },
    //最大时间
    maxDate: {
      type: String,
      default: ""
    },
    //格式化
    format: {
      type: String,
      default: ""
    },
    //类型
    type: {
      type: String,
      default: "date"
    },
    //确认描述
    confirmButtonText: {
      type: String,
      default: "确认"
    },
    //取消描述
    cancelButtonText: {
      type: String,
      default: defaultCancelButtonText
    },
    //提示
    placeholder: {
      type: String,
      default: "请选择"
    },
    //过滤方法
    filter: {
      type: Function
    }
  },
  data() {
    return {
      visible: false,
      realValue: "",
      baseFormat: {
        datetime: "YYYY-MM-DD HH:mm",
        date: "YYYY-MM-DD",
        time: "HH:mm",
        "year-month": "YYYY-MM"
      }
    };
  },
  watch: {
    realValue(e) {
      if (this.realValue !== this.value) {
        this.$emit("input", e);
      }
    },
    value(e) {
      if (this.realValue != this.value) {
        this.realValue = e;
      }
    }
  },
  created() {
    this.realValue = this.value;
  },
  methods: {
    /**
     * @description: 获取值
     * @param {*}
     * @return {*}
     */
    getValue() {
      return this.realValue;
    },
    /**
     * @description: 赋值
     * @param {*}
     * @return {*}
     */
    setValue(e) {
      this.realValue = e;
    },
    /**
     * @description: 格式化
     * @param {*} type
     * @param {*} val
     * @return {*}
     */
    formatter(type, val) {
      switch (type) {
        case "year":
          return `${val}年`;
        case "month":
          return `${val}月`;
        case "day":
          return `${val}日`;
        case "hour":
          return `${val}时`;
        case "minute":
          return `${val}分`;
        default:
          return val;
      }
    },
    /**
     * @description: 打开弹窗
     * @param {*}
     * @return {*}
     */
    popupShow() {
      this.visible = true;
    },
    /**
     * @description: 确认
     * @param {*} val
     * @return {*}
     */
    confirm(e) {
      this.realValue = e;
      this.$emit("change", e);
      this.visible = false;
    },
    /**
     * @description: 取消
     * @param {*}
     * @return {*}
     */
    cancel() {
      if (!this.required) {
        this.realValue = "";
        this.$emit("change", "");
      }
      this.visible = false;
    },
    /**
     * @description: 输入框 渲染
     * @param {*}
     * @return {*}
     */
    fieldRender() {
      let { readonly, disabled } = this;
      readonly = readonly || disabled;
      let option = {
        props: {
          readonly: true,
          label: this.title,
          labelWidth: this.titleWidth,
          required: this.required,
          value: this.realValue
        },
        ref: "input"
      };
      if (!readonly) {
        option.props.placeholder = this.placeholder;
        option.props.rightIcon = "arrow-down";
        option.on = {
          click: this.popupShow
        };
      }
      return <van-field {...option} />;
    },
    /**
     * @description: 弹窗 渲染
     * @param {*}
     * @return {*}
     */
    popupDateTimePickerRender() {
      const { cancelButtonText, required } = this;
      const option = {
        props: {
          value: this.realValue,
          visible: this.visible,
          type: this.type,
          cancelButtonText:
            cancelButtonText != defaultCancelButtonText
              ? cancelButtonText
              : required
              ? defaultClearButtonText
              : defaultCancelButtonText,
          confirmButtonText: this.confirmButtonText,
          minDate: this.minDate,
          maxDate: this.maxDate,
          closeOnClickOverlay: this.closeOnClickOverlay
        },
        on: {
          input: e => {
            this.visible = e;
          },
          confirm: this.confirm
        }
      };
      return <popupDateTimePicker {...option} />;
    }
  },
  render() {
    return (
      <div>
        {this.fieldRender()}
        <div />
        {this.popupDateTimePickerRender()}
      </div>
    );
  }
};
</script>

<style lang="less" scoped></style>
